import { createContext, useContext } from "react";
import { Animated } from "react-native";

/**
 * Determine the scroll position of the current page as an animated value that can be used to perform
 * animations on elements of the page.
 */
export const useScrollYPosition = (): Animated.Value => useContext(ScrollYPosition);

export const ScrollYPosition = createContext(new Animated.Value(0));
